import React, { useState } from 'react';
import { Controller } from 'react-hook-form'; // Assuming you're using react-hook-form
import UseMediaLibrary from '../UseMediaLibrary';

export interface MediaInputProps {
  name: string;
  control: any;
  label: string;
}

const MediaInput: React.FC<MediaInputProps> = ({ name, control, label }) => {
  const [image, setImage] = useState<File | null>(null);
  const [saveVideoUrl, setSaveVideoUrl] = useState("");
  const [open, setOpen] = React.useState(false);
  const [isHovered, setIsHovered] = useState(true);

  const [relationFilter, setRelationFilter] = useState<any>([
       {
      relationType: "elementType",
      relationItemId: "icon",
    },
  ]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission if needed
    console.log('Image submitted:', image);
  };


  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    // setClickedButtonIndex(null);
  };
  const handleEditClick = (event: any) => {
    setOpen(true);
  };

  const handleDeleteClick = (field:any) => {
    setSaveVideoUrl("");
    field.onChange("")
  };

  const handleSelectImage = (url:string, field:any) => {
    setSaveVideoUrl(url);
    field.onChange(url); // Update the value in the form
    setOpen(false);
  };
  

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (           

            <div className="basis-1/2">
              <div >
                <div className={`h-[calc(100%-26px)] w-full}`}>
                  <>
                    <div
                      className="relative inline-block w-full" style={{
                        width: '170px',
                        height: '100px',
                        borderRadius: '10px',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        verticalAlign: 'middle',
                        cursor: 'pointer',
                      }}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                    {field.value &&               
                      <>
                      <img className={`border cursor-pointer rounded-lg w-full h-full p-4`} src={field.value} />
                      {isHovered && (
                              <>   
                                <div className="absolute cursor-pointer top-1 end-0.5">
                                  <button
                                  type="button"
                                    className={`bg-white text-[16px] opacity rounded-full`}
                                    onClick={(e) => {
                                      handleEditClick(e);
                                      setOpen(true);
                                      e.preventDefault();
                                    }}
                                  >
                                    {/* <FontAwesomeIcon icon={faPencil} /> */}
                                    <svg
                                      width="25"
                                      height="25"
                                      viewBox="0 0 32 32"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        width="32"
                                        height="32"
                                        rx="16"
                                        fill="white"/>
                                      <g clipPath="url(#clip0_1211_426)">
                                        <path
                                          d="M23.2353 8.7653C22.7821 8.31277 22.1678 8.05859 21.5273 8.05859C20.8869 8.05859 20.2726 8.31277 19.8193 8.7653L8.97668 19.608C8.66618 19.9167 8.41998 20.284 8.25234 20.6885C8.0847 21.093 7.99893 21.5268 8.00001 21.9646V23.3333C8.00001 23.5101 8.07025 23.6797 8.19527 23.8047C8.3203 23.9297 8.48987 24 8.66668 24H10.0353C10.4732 24.0012 10.9069 23.9156 11.3114 23.748C11.716 23.5805 12.0832 23.3344 12.392 23.024L23.2353 12.1806C23.6877 11.7274 23.9417 11.1133 23.9417 10.473C23.9417 9.83266 23.6877 9.21851 23.2353 8.7653ZM11.4493 22.0813C11.0733 22.4548 10.5653 22.6651 10.0353 22.6666H9.33334V21.9646C9.33267 21.7019 9.38411 21.4416 9.4847 21.1989C9.58529 20.9562 9.73302 20.7359 9.91934 20.5506L18.148 12.322L19.6813 13.8553L11.4493 22.0813ZM22.292 11.238L20.6213 12.9093L19.088 11.3793L20.7593 9.70797C20.86 9.60751 20.9795 9.52786 21.111 9.47358C21.2424 9.41929 21.3833 9.39143 21.5255 9.39158C21.6678 9.39174 21.8086 9.41991 21.9399 9.47448C22.0712 9.52905 22.1905 9.60896 22.291 9.70964C22.3915 9.81032 22.4711 9.9298 22.5254 10.0613C22.5797 10.1927 22.6076 10.3336 22.6074 10.4758C22.6072 10.618 22.5791 10.7588 22.5245 10.8902C22.4699 11.0215 22.39 11.1408 22.2893 11.2413L22.292 11.238Z"
                                          fill="#2D64BC"/>
                                        <clipPath id="clip0_1211_426">
                                          <rect
                                            width="16"
                                            height="16"
                                            fill="white"
                                            transform="translate(8 8)" />
                                        </clipPath>
                                      </g>
                                      <defs>
                                      </defs>
                                    </svg>
                                  </button>
                                  <button
                                    className={`bg-white fs-16 opacity rounded-full`}
                                    onClick={(e) => {
                                      handleDeleteClick(field);
                                      e.preventDefault();
                                    }}
                                  >
                                    <svg
                                      width="25"
                                      height="25"
                                      viewBox="0 0 32 32"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        width="32"
                                        height="32"
                                        rx="16"
                                        fill="white" />
                                      <g clipPath="url(#clip0_1211_428)">
                                        <path
                                          d="M22.0002 10.6667H19.9335C19.7788 9.91428 19.3694 9.23823 18.7743 8.75248C18.1793 8.26673 17.435 8.00097 16.6668 8H15.3335C14.5654 8.00097 13.821 8.26673 13.226 8.75248C12.6309 9.23823 12.2216 9.91428 12.0668 10.6667H10.0002C9.82335 10.6667 9.65378 10.7369 9.52876 10.8619C9.40373 10.987 9.3335 11.1565 9.3335 11.3333C9.3335 11.5101 9.40373 11.6797 9.52876 11.8047C9.65378 11.9298 9.82335 12 10.0002 12H10.6668V20.6667C10.6679 21.5504 11.0194 22.3976 11.6443 23.0225C12.2692 23.6474 13.1164 23.9989 14.0002 24H18.0002C18.8839 23.9989 19.7311 23.6474 20.356 23.0225C20.9809 22.3976 21.3324 21.5504 21.3335 20.6667V12H22.0002C22.177 12 22.3465 11.9298 22.4716 11.8047C22.5966 11.6797 22.6668 11.5101 22.6668 11.3333C22.6668 11.1565 22.5966 10.987 22.4716 10.8619C22.3465 10.7369 22.177 10.6667 22.0002 10.6667ZM15.3335 9.33333H16.6668C17.0803 9.33384 17.4836 9.46225 17.8212 9.70096C18.1589 9.93967 18.4144 10.277 18.5528 10.6667H13.4475C13.5859 10.277 13.8414 9.93967 14.1791 9.70096C14.5167 9.46225 14.92 9.33384 15.3335 9.33333ZM20.0002 20.6667C20.0002 21.1971 19.7894 21.7058 19.4144 22.0809C19.0393 22.456 18.5306 22.6667 18.0002 22.6667H14.0002C13.4697 22.6667 12.961 22.456 12.5859 22.0809C12.2109 21.7058 12.0002 21.1971 12.0002 20.6667V12H20.0002V20.6667Z"
                                          fill="#EB5757" />
                                        <path
                                          d="M14.6667 19.9993C14.8435 19.9993 15.013 19.9291 15.1381 19.8041C15.2631 19.6791 15.3333 19.5095 15.3333 19.3327V15.3327C15.3333 15.1559 15.2631 14.9863 15.1381 14.8613C15.013 14.7363 14.8435 14.666 14.6667 14.666C14.4899 14.666 14.3203 14.7363 14.1953 14.8613C14.0702 14.9863 14 15.1559 14 15.3327V19.3327C14 19.5095 14.0702 19.6791 14.1953 19.8041C14.3203 19.9291 14.4899 19.9993 14.6667 19.9993Z"
                                          fill="#EB5757" />
                                        <path
                                          d="M17.3332 19.9993C17.51 19.9993 17.6796 19.9291 17.8046 19.8041C17.9296 19.6791 17.9998 19.5095 17.9998 19.3327V15.3327C17.9998 15.1559 17.9296 14.9863 17.8046 14.8613C17.6796 14.7363 17.51 14.666 17.3332 14.666C17.1564 14.666 16.9868 14.7363 16.8618 14.8613C16.7367 14.9863 16.6665 15.1559 16.6665 15.3327V19.3327C16.6665 19.5095 16.7367 19.6791 16.8618 19.8041C16.9868 19.9291 17.1564 19.9993 17.3332 19.9993Z"
                                          fill="#EB5757" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1211_428">
                                          <rect
                                            width="16"
                                            height="16"
                                            fill="white"
                                            transform="translate(8 8)"/>
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </button>
                                </div>
                              </>
                             )}  
                      </>
                      }
             
             {!field.value &&  
              <div className="border border-dashed flex border-[var(--primary-color)] rounded-[5px] h-full bg-[#2D64BC0F]"  onClick={() => {setOpen(true)}}>
              <label htmlFor="videoInput"  className="m-auto cursor-pointer">
                <div className="relative">
                  <div className="flex justify-center items-center">
                    <svg
                      className="pointer"
                      width="41"
                      height="41"
                      viewBox="0 0 51 51"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_947_347)">
                        <path
                          d="M42.1588 18.8806C39.8479 9.67477 30.5119 4.08535 21.3061 6.39623C14.112 8.20218 8.88821 14.42 8.34998 21.8177C3.24185 22.6601 -0.216266 27.4839 0.626122 32.592C1.37497 37.1332 5.30989 40.4589 9.91231 40.4406H17.724V37.316H9.91231C6.46093 37.316 3.663 34.5181 3.663 31.0667C3.663 27.6153 6.46093 24.8174 9.91231 24.8174C10.7752 24.8174 11.4746 24.1179 11.4746 23.255C11.4668 15.4894 17.7559 9.18772 25.5215 9.18C32.2439 9.17327 38.0306 13.9257 39.331 20.521C39.4594 21.1795 39.9938 21.6825 40.6589 21.7708C44.9302 22.379 47.8995 26.3346 47.2913 30.6057C46.7452 34.441 43.4706 37.2967 39.5966 37.316H33.3472V40.4406H39.5966C45.6365 40.4224 50.518 35.5112 50.4997 29.4712C50.4844 24.4435 47.043 20.0737 42.1588 18.8806Z"
                          fill="#2D64BC"
                        />
                        <path
                          d="M24.4263 25.2708L18.177 31.5201L20.3799 33.7229L23.9732 30.1452V45.128H27.0979V30.1452L30.6756 33.7229L32.8785 31.5201L26.6292 25.2708C26.0198 24.665 25.0357 24.665 24.4263 25.2708Z"
                          fill="#2D64BC"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_947_347">
                          <rect
                            width="50"
                            height="50"
                            fill="white"
                            transform="translate(0.5 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
            
                  <p className="text-center leading-[21px] font-medium text-[14px] text-[var(--primary-color)]">Upload icon</p>
                </div>
              </label>
              </div>
              }
                    </div>
                  </>
                  {open && (
                  <UseMediaLibrary
                  url={URL}
                  relationFilter={relationFilter}
                  saveVideo={(selectedVideo: any) =>
                    setSaveVideoUrl(selectedVideo)
                  }
                  isOpen={open}
                  onClose={() => {
                    setOpen(false);
                  }}
                  onDataSelected={(selectedData: any) => {
                    setSaveVideoUrl(selectedData.iconUrl);
                    field.onChange(selectedData.iconUrl);
                    handleSelectImage(selectedData.iconUrl, field)
                  }}
                /> 
               ) }     
                </div>
              </div>
            </div>


          )}
        />
      </form>
    </div>
  );
};

export default MediaInput;
